import classNames from 'classnames'

import RichText from '@src/quince-site-common/src/domains/RichText'
import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { RichText as RichTextC, RichTextProps } from '../../molecules'
import Accordian, { AccordianProps } from '../accordian'

import styles from './faqSection.module.scss'

export interface FAQSectionProps {
  header?: RichText | null
  accordianData: AccordianProps
  className?: string
  headerClassName?: string
  /** Renders the header text in medium weight. Use instead of checking headerClassName in DS consumers. */
  boldHeader?: boolean
  title?: string
  showFirstQuestionExpanded?: boolean
  productProperties?: ProductProperties
  showNewPdpDesignV2?: boolean
  initialExpandedIndices?: number[]
  onItemToggle?: (index: number, isOpen: boolean) => void
}

const FAQSection = ({
  title = '',
  header = null,
  accordianData = { data: [] },
  className = '',
  headerClassName = '',
  showFirstQuestionExpanded = false,
  productProperties,
  showNewPdpDesignV2,
  initialExpandedIndices,
  onItemToggle,
}: FAQSectionProps) => {
  const classes = classNames(styles.wrapper, className)
  const headerRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(header)

  const sendFAQViewedEvent = () => {
    trackEvent(TELEMETRY_EVENT_NAMES.FAQ_VIEWED, {
      no_of_FAQ_cards: accordianData.data.length,
    })
  }

  const getIsVisibleTrackParams = () => null

  const { ref: isFAQVisible } = useTrackIsElementVisible(getIsVisibleTrackParams, sendFAQViewedEvent)

  return (
    <div ref={isFAQVisible} id={title.toLowerCase()} className={classes}>
      <div className={`${styles.wrapper__text} ${headerClassName || ''}`}>
        {header && headerRichTextProps && <RichTextC {...headerRichTextProps} />}
      </div>
      <Accordian
        {...accordianData}
        showFirstAccordionExpanded={showFirstQuestionExpanded}
        productProperties={productProperties}
        showNewPdpDesignV2={showNewPdpDesignV2}
        initialExpandedIndices={initialExpandedIndices}
        onItemToggle={onItemToggle}
      />
    </div>
  )
}

export default FAQSection
